import { Component, createRef, type ReactNode } from 'react';
export type ScrollSnapshot = { element: HTMLElement; top: number; left: number }[];
export function captureScroll(root: HTMLElement | null): ScrollSnapshot {
  const snapshot: ScrollSnapshot = [];
  let node = root;
  while (node) { snapshot.push({ element: node, top: node.scrollTop, left: node.scrollLeft }); node = node.parentElement; }
  return snapshot;
}
export function restoreScroll(snapshot: ScrollSnapshot): void {
  for (const row of snapshot) { row.element.scrollTop = row.top; row.element.scrollLeft = row.left; }
}
/** Snapshot before React commits, including the actual outer panel scroll container. */
export class StablePlaySurface extends Component<{ children: ReactNode }, object, ScrollSnapshot> {
  private root = createRef<HTMLDivElement>();
  getSnapshotBeforeUpdate(): ScrollSnapshot { return captureScroll(this.root.current); }
  componentDidUpdate(_props: unknown, _state: unknown, snapshot: ScrollSnapshot): void { restoreScroll(snapshot); }
  render() { return <div ref={this.root} className="dcc-stable-play-surface">{this.props.children}</div>; }
}
